import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AdminAuthService } from '../../../services/auth/admin-auth.service';
import { Utilities } from 'reg-hub-common';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CallbackComponent {
  constructor(private _authService: AdminAuthService, private _router: Router) { }
  ngOnInit(): void {
    if (this._authService.isLoggedIn()) {
      const returnUrl = sessionStorage.getItem('returnUrl') || '/dashboard';

      const sanitizedUrl = Utilities.sanitizeRelativeURL(returnUrl, "admin");
      // clear item from session storage
      sessionStorage.removeItem('returnUrl');

      this._router.navigateByUrl(sanitizedUrl);
    }
  }
}
